import I18n from 'I18n';
import { CRM_PROPERTIES, fetchCrmObjectsByType } from 'personalization-lib/api/clients/crmApiClient';
import { OBJECT_TYPE_IDS } from 'personalization-lib/constants/objectTypeIds';
import { WEB_INTERACTIVES_URL } from 'personalization-lib/constants/urls';
import { notHasProperty, propertyNotEquals } from 'personalization-lib/utils/assetData/crm';
import { fetchContentById } from '../contentApiClient';
export const fetchWebInteractive = id => fetchContentById({
  url: WEB_INTERACTIVES_URL,
  id
});
const WEB_INTERACTIVE_FILTERS = [propertyNotEquals(CRM_PROPERTIES.IS_SMART, 'true'), propertyNotEquals(CRM_PROPERTIES.IS_ACTIVE_AB_TEST, 'true'), notHasProperty(CRM_PROPERTIES.PERSONALIZATION_STRATEGY_ID), propertyNotEquals(CRM_PROPERTIES.CONTAINER_TYPE, 'EMBEDDED'), propertyNotEquals(CRM_PROPERTIES.PARENT_SOURCE, 'FEEDBACK')];
export const fetchWebInteractivesOptions = paginationParams => fetchCrmObjectsByType(Object.assign({
  objectTypeId: OBJECT_TYPE_IDS.WEB_INTERACTIVE,
  properties: [CRM_PROPERTIES.NAME, CRM_PROPERTIES.SCREENSHOT_URL, CRM_PROPERTIES.CONTAINER_TYPE, CRM_PROPERTIES.CONTENT_ID],
  filters: WEB_INTERACTIVE_FILTERS
}, paginationParams)).then(({
  total,
  offset,
  results
}) => ({
  total,
  offset,
  results: results.map(({
    id,
    name,
    imgSrc,
    containerType
  }) => ({
    value: id.toString(),
    text: name,
    help: I18n.text(`personalizationLib.variantForm.assetSelect.WEB_INTERACTIVE.help.${containerType}`),
    screenshot: imgSrc
  }))
}));